import { useState } from 'react';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
              <i className="ri-recycle-line text-white text-xl"></i>
            </div>
            <span className="text-2xl font-bold text-gray-900">Kagesi</span>
          </div>

          <div className="hidden lg:flex items-center gap-8">
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              About Us
            </button>
            <button onClick={() => scrollToSection('solutions')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Solutions
            </button>
            <button onClick={() => scrollToSection('technology')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Technology
            </button>
            <button onClick={() => scrollToSection('impact')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Impact
            </button>
            <button onClick={() => scrollToSection('projects')} className="text-gray-700 hover:text-emerald-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Projects
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-emerald-600 text-white px-6 py-2.5 rounded-lg hover:bg-emerald-700 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Get in Touch
            </button>
          </div>

          <button 
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100">
          <div className="px-6 py-4 space-y-3">
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-gray-700 hover:text-emerald-600 py-2 font-medium cursor-pointer">
              About Us
            </button>
            <button onClick={() => scrollToSection('solutions')} className="block w-full text-left text-gray-700 hover:text-emerald-600 py-2 font-medium cursor-pointer">
              Solutions
            </button>
            <button onClick={() => scrollToSection('technology')} className="block w-full text-left text-gray-700 hover:text-emerald-600 py-2 font-medium cursor-pointer">
              Technology
            </button>
            <button onClick={() => scrollToSection('impact')} className="block w-full text-left text-gray-700 hover:text-emerald-600 py-2 font-medium cursor-pointer">
              Impact
            </button>
            <button onClick={() => scrollToSection('projects')} className="block w-full text-left text-gray-700 hover:text-emerald-600 py-2 font-medium cursor-pointer">
              Projects
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left bg-emerald-600 text-white px-6 py-2.5 rounded-lg hover:bg-emerald-700 font-medium cursor-pointer">
              Get in Touch
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
